<template>
  <v-btn color="#4BEC66" rounded dark dense @click="goToWhatsapp()">
    <v-icon class="mr-1">mdi-whatsapp</v-icon>
    Precisando de ajuda?
  </v-btn>
</template>
<script>
export default {
  methods: {
    goToWhatsapp() {
      window.open('https://wa.me/5511961701736', '_blank')
    }
  }
}
</script>
